import { z } from 'zod';

import { useStore } from '../../store';

const TableauTokenResponse = z.object({
  tableau_token: z.string(),
});

export type TableauTokenResponse = z.infer<typeof TableauTokenResponse>;

export async function getTableauToken(): Promise<TableauTokenResponse> {
  try {
    const { session } = useStore.getState();

    const response = await session?.getPortalApiClient()?.http.request({
      path: '/api/v1/tableau/token',
      secure: true,
    });
    const res = await response?.json();
    return TableauTokenResponse.parse(res);
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
